import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';

class AppSaveReturn extends Component {
    render(){
        function saveFilterOption(){
            let values = this.props.filterValue;
            let result = "";
            values.forEach(el => {
                result+=(el+'&');
            });
            localStorage.setItem(window.location.pathname.replace("/", ""), result);
            
        }
        return(
            <footer>
                <NavLink onClick={saveFilterOption.bind(this)} to="/">
                    Opslaan
                </NavLink>
            </footer>
        )
    }
}

export default AppSaveReturn;